<template>
  <div
    class="image-modal-wrapper position-fixed align-items-center justify-content-center d-flex position-fixed">
    <div class="modal-inner align-items-center justify-content-center d-flex h-100 w-100">
      <div
        class="bm-image-modal-content im-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Add Video">
        <div class="im-header">
          <h2 class="modal-heading">Add Video</h2>
          <button
            type="button"
            class="im-close"
            aria-label="Close"
            title="Close"
            @click="closeModal">
            <icon name="close-icon"/>
          </button>
        </div>
        <div class="bm-modal-body border-0">
          <div class="tabs-wrapper">
            <div class="tabs-inner">
              <ul class="list-unstyled im-tabs mb-0">
                <li>
                  <tab
                    :id="3"
                    :tab-active="selectedId"
                    title="Stock videos"
                    @click="selectedId = '3'"/>
                </li>
                <li>
                  <tab
                    :id="2"
                    :tab-active="selectedId"
                    title="My computer"
                    @click="selectedId = '2'"/>
                </li>
                <li>
                  <tab
                    :id="1"
                    :tab-active="selectedId"
                    title="My gallery"
                    @click="selectedId = '1'"/>
                </li>
              </ul>
            </div>

            <div class="main-tabs-content">
              <div
                v-if="selectedId == 1"
                class="video-gallery-empty">
                <div class="video-empty">
                  <span class="video-empty-badge">
                    <icon name="film"/>
                  </span>
                  <span class="video-empty-title">Coming Soon...</span>
                  <span class="video-empty-copy">Your uploaded videos will appear here. Upload from My computer for now.</span>
                </div>
              </div>
              <div
                v-show="selectedId == 2"
                class="file-select">
                <video-file-select/>
              </div>
              <div v-if="selectedId == 3">
                <stock-video-box/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="backdrop position-fixed h-100 w-100"
      @click="closeModal"/>
  </div>
</template>

<script>
import Tab from '@/components/Tab/Tab';
import EventBus from '../../EventBus';
import VideoFileSelect from '../VideoFileSelect/VideoFileSelect';
import StockVideoBox from '../StockVideoBox/StockVideoBox';

export default {
  components: {
    tab:                 Tab,
    'video-file-select': VideoFileSelect,
    'stock-video-box':   StockVideoBox,
  },
  data() {
    return {
      selectedId: '3',
    };
  },
  mounted() {
    EventBus.$on('toggleTabs', this.handleTabClick);
    EventBus.$on('AddNewVideoOnCanvas', this.onAddNewVideoOnCanvas);
  },
  beforeDestroy() {
    EventBus.$off('toggleTabs', this.handleTabClick);
    EventBus.$off('AddNewVideoOnCanvas', this.onAddNewVideoOnCanvas);
  },
  methods: {
    handleTabClick(id) {
      this.selectedId = id;
    },
    onAddNewVideoOnCanvas(videoData) {
      console.log(videoData);
      // EventBus.$emit('onAddingNewObjectVideo', videoData);// onAddingNewObjectImage
    },
    closeModal() {
      EventBus.$emit('abortVideoUpload');
      this.$store.commit('setDisplayAddVideoModal', false);
      this.$store.commit('setIsVideoModel', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-gallery-empty {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: 24px;
}

.video-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 280px;
  text-align: center;
}

.video-empty-badge {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #F3F4F6;
  color: #5E6573;
}

.video-empty-title {
  font-size: 14px;
  font-weight: 650;
  line-height: 1.3;
  color: #14161B;
}

.video-empty-copy {
  font-size: 12.5px;
  line-height: 1.5;
  color: #5E6573;
}

.video-empty-badge ::v-deep .icon {
  min-width: 0;
  min-height: 0;
  color: inherit;
}

.video-empty-badge ::v-deep .icon svg {
  display: block;
  width: 22px;
  height: 22px;
}
</style>
